import { render, staticRenderFns } from "./LabelView.vue?vue&type=template&id=080353a6&scoped=true&"
import script from "./LabelView.vue?vue&type=script&lang=js&"
export * from "./LabelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080353a6",
  null
  
)

export default component.exports